import React from 'react'
import Header from '../components/Header/Header'
import Navbar from '../components/Navbar/Navbar'

const Senior_Scientist_Award = () => {
  return (
    <div>
      <Header />
      <Navbar />
      <div className="px-4">
        <div className="max-w-7xl mx-auto bg-white p-6 ">
          {/* Header Section */}
          <header className="flex justify-between items-center mb-2 pb-6">
            <h1 className="text-3xl md:text-4xl text-blue-800 ">I.I.S. Awards</h1>
            {/* <img
                        src={iisLogo} 
                        alt="Indian Immunology Society Logo"
                        className="w-32 md:w-40 rounded-full"
                      /> */}
          </header>

          {/* Content Section */}
          <section>
            <h2 className="text-2xl md:text-3xl text-gray-600 mb-4 ">IIS Senior Scientist Award</h2>
            <p className="text-md md:text-lg text-gray-600 mb-4">
              The IIS Senior Scientist Award is presented to an eminent scientist above the age of 50 who has made outstanding and significant contributions to the field of Immunology. The recipient of this prestigious award must have demonstrated sustained activity and dedication to their research over many years.   </p>

            <p className="text-md md:text-lg text-gray-600 mb-4">
              If selected for the Senior Scientist Oration award, the awardee will be notified at least two weeks before the annual meeting of the Society and will be invited to deliver a 30-minute oration during the IIS Annual Conference. In addition to the Certificate of Honour and Medal, the awardee will receive a Cash Prize of Rs. 30,000/-.
            </p>

            <p className="text-md md:text-lg text-gray-600 mb-4">
              Nominations, including self-nominations, should be submitted on the prescribed 'Application/Nomination Form for IIS-Awards' by the deadline of 31st August, 2024. All nominations must be emailed to indianimmunologysociety2024@gmail.com with a CC to kaustuvnayak@gmail.com, with the subject line "IIS Senior Scientist Award." The selected awardee will be announced by mid-September, 2024.

            </p>
            <p>
              For further details, including eligibility and application procedures, please visit the IIS website at  <a
            href="https://www.indianimmunologysociety.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-500 underline hover:text-indigo-800"
          >
            click me
          </a>.
             
          
            </p>
          </section>
        </div>
        <div className="bg-gray-100 mt-6 py-4">
          <div className="max-w-7xl mx-auto px-4 text-center">
            
            <p className="text-base mb-6">
              Nomination Form:
              <a
                href="/nomination_form.pdf"
                download
                className="text-[#4f46e5] underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                click here
              </a>
              
              .
            </p>
            <p className="text-base mb-6">
              Guideline:
              <a
                href="/guidelines.pdf"
                download
                className="text-[#4f46e5] underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                click here
              </a>
              .
            </p>

          </div>
        </div>
      </div>

    </div>
  )
}

export default Senior_Scientist_Award
